<aims-side-menu [component]="permissions.ComponentID.Config">
  <ng-template>
    <aims-side-menu-header [displayText]="'Config'">
      <aims-side-menu-link [route]="'./'" [component]="permissions.ComponentID.Config"
        [iconClass]="'fas fa-map-marked-alt'">
        Company Sites
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./states'" [component]="permissions.ComponentID.Config"
        [iconClass]="'fas fa-flag-usa'">
        States/Territories
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./scheduledMaintenanceGenerator'"
        [iconClass]="'fas fa-tachometer-alt'">
        Scheduled Maintenance Generator
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./manageMacs'"
        [iconClass]="'fas fa-list-ol'">
        Manage Mac Addresses
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./manageUsers'"
        [iconClass]="'fas fa-users'">
        Manage Users
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./password'" [component]="permissions.ComponentID.Config"
        [iconClass]="'fas fa-cog'">
        Password Expiration
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./cache'" [component]="permissions.ComponentID.Config"
        [iconClass]="'fas fa-database'">
        Data Cache
      </aims-side-menu-link>
    </aims-side-menu-header>
  </ng-template>
</aims-side-menu>
